export default {"src":"/_next/static/media/tutorial-replay.d8a6e4c1.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};